<template>
  <v-footer app>
    <v-container fluid>
      <v-row justify="space-around" align-content="center">
        <a :href="link" target="_blank" style="color: #2c3e50;">
          Created by
          {{ label }}, 2020
        </a>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    link: "https://github.com/yugaWicaksono",
    label: "CYW",
  }),
};
</script>
